/* Noorns redesign: header behavior (mockup build_pages.py MENU_JS_CODE, header parts only).
   - Shop by concern and Learn open on hover (CSS) and on click; the account menu on click; click outside or Escape closes them.
   - The phone menu drawer opens from the menu button and closes on the shade, the close button or Escape.
   - A soft shadow under the sticky header once the page scrolls (Cam, 2026-10-07). Horizon 4.2 scrolls
     .page-wrapper on wide screens and the window on phones, so both are watched. */
(function () {
  var root = document.getElementById('noorns-header');
  if (!root) return;

  /* Every header menu: Shop by concern, the Learn dropdown and the account menu (Cam, 2026-10-08). A click on its
     button opens it and closes the others; a click outside, Escape, or Tab moving focus out closes it. The two in
     the main nav also open on hover, as the mockup does; the account menu opens on click only. */
  var menus = [].slice.call(root.querySelectorAll('.nw-header .has-menu')).map(function (w) {
    return { w: w, b: w.querySelector(':scope > button'), hover: !w.classList.contains('acct') };
  }).filter(function (x) { return x.b; });
  function setOpen(x, o) { x.w.classList.toggle('open', o); x.b.setAttribute('aria-expanded', o); }
  menus.forEach(function (x) {
    x.b.addEventListener('click', function () {
      var o = !x.w.classList.contains('open');
      menus.forEach(function (y) { if (y !== x) setOpen(y, false); });
      setOpen(x, o);
    });
    /* Down arrow on the button opens its panel and moves to the first link (walk finding I6) */
    x.b.addEventListener('keydown', function (ev) {
      if (ev.key !== 'ArrowDown') return;
      ev.preventDefault();
      menus.forEach(function (y) { if (y !== x) setOpen(y, false); });
      setOpen(x, true);
      var first = x.w.querySelector('#' + x.b.getAttribute('aria-controls') + ' a[href]');
      if (first) first.focus();
    });
    x.w.addEventListener('focusout', function (ev) { if (ev.relatedTarget && !x.w.contains(ev.relatedTarget)) setOpen(x, false); });
    if (x.hover) {
      x.w.addEventListener('mouseenter', function () { x.b.setAttribute('aria-expanded', true); });
      x.w.addEventListener('mouseleave', function () { if (!x.w.classList.contains('open')) x.b.setAttribute('aria-expanded', false); });
    }
  });
  document.addEventListener('click', function (ev) { menus.forEach(function (x) { if (!x.w.contains(ev.target)) setOpen(x, false); }); });

  var d = document.getElementById('drawer'), ob = document.getElementById('menu-open'), lastFocus = null;
  function shut() {
    if (!d || d.hidden) return;
    d.hidden = true; ob.setAttribute('aria-expanded', false);
    document.documentElement.classList.remove('nhd-drawer-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (d && ob) {
    ob.addEventListener('click', function () {
      lastFocus = ob; d.hidden = false; ob.setAttribute('aria-expanded', true);
      document.documentElement.classList.add('nhd-drawer-open');
      document.body.style.overflow = 'hidden';
      var x = document.getElementById('menu-close'); if (x) x.focus();
    });
    d.querySelectorAll('[data-close]').forEach(function (x) { x.addEventListener('click', shut); });
    window.matchMedia('(min-width: 961px)').addEventListener('change', function (e) { if (e.matches) shut(); });
  }
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    shut();
    menus.forEach(function (x) {
      var inside = x.w.contains(document.activeElement);
      if (x.w.classList.contains('open') || inside) { setOpen(x, false); if (inside) x.b.focus(); }
    });
  });

  var pw = document.querySelector('.page-wrapper'), tick = false;
  function shadow() {
    var y = Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0);
    root.classList.toggle('is-scrolled', y > 8);
    tick = false;
  }
  function onScroll() { if (!tick) { tick = true; requestAnimationFrame(shadow); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
  shadow();
})();
